/**
 * Salesforce spreadsheet → CRM upsert helpers (read-only / filterable duplicate search).
 * Not used for HubSpot.
 */
import type {
  MappingConfig,
  SalesforceFieldForMapping
} from '../types/salesforce';

/** Standard Account Account Name API name */
const SALESFORCE_ACCOUNT_NAME_FIELD_API = 'Name';

export function spreadsheetCellIsBlankForCrmSync(value: unknown): boolean {
  return value == null || String(value).trim() === '';
}

/** Source spreadsheet column mapped to Account `Name`, or null if unmapped / not Account. */
export function mappedSalesforceAccountNameSourceColumn(
  mapping: MappingConfig
): string {
  const field = mapping.fields.find(
    (f) => f.target_field_api_name === SALESFORCE_ACCOUNT_NAME_FIELD_API
  );
  return field?.source_col!;
}

export function salesforceFieldEligibleForPrimaryKey(
  field: SalesforceFieldForMapping | undefined
): boolean {
  if (!field) return false;
  if (field.isFilterable === false) return false;
  return true;
}

/** Schema hint: Salesforce will not persist values but queries can filter (aligns with read-only duplicate search). */
export function salesforceFieldSupportsReadOnlySearch(
  field: SalesforceFieldForMapping | undefined
): boolean {
  if (!field) return false;
  const writable = field.isCreateable === true || field.isUpdateable === true;
  if (writable) return false;
  if (field.isFilterable === false) return false;
  return true;
}

export function salesforceMappedTargetsIncludeReadOnlySearchField(
  targetFieldApiNames: string[],
  crmFields: SalesforceFieldForMapping[]
): boolean {
  for (const api of targetFieldApiNames) {
    const meta = crmFields.find((f) => f.apiName === api);
    if (salesforceFieldSupportsReadOnlySearch(meta)) return true;
  }
  return false;
}
